import { TextInput } from '@pwc/pwc-deals-ui';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { getSurveyResponses } from '../../../surveySlice';

import { validate } from '../../../common/services/utilities/surveyUtility';

import './QuestionPercent.scss';

const QuestionPercent = ({
  question,
  userAnswer,
  setUserAnswer,
  setIsAnswerValid,
}) => {
  const [errorMsg, setErrorMsg] = useState('');

  const responses = useSelector(getSurveyResponses);

  useEffect(() => {
    const answer =
      responses &&
      responses.answers.find((ans) => ans.questionId === question.id);
    if (answer) {
      setUserAnswer(answer.value);
    } else {
      setUserAnswer(null);
    }
  }, [question.id, setUserAnswer, responses]);

  useEffect(() => {
    const { isValid, errorMessage } = validate.questionPercent(userAnswer);
    setIsAnswerValid(isValid);
    setErrorMsg(errorMessage || '');
  }, [userAnswer, setIsAnswerValid]);

  const field = {
    value: userAnswer,
    onChange: (event) => {
      setUserAnswer(`${+event.target.value}`);
    },
  };

  return (
    <div className="survey-percent-container">
      <p>{question.text}</p>
      <TextInput
        className="survey-percent-input"
        field={field}
        error={errorMsg}
        type="number"
        min={0}
        max={100}
      />
    </div>
  );
};

export default QuestionPercent;
